/** @format */

export interface ContactForm {
  email: string;
  first_name?: string;
  last_name?: string;
  phone?: string;
}
